import type { admin } from '@headless/api-types'
import { DOCUMENT, NgFor } from '@angular/common'
import { Component, Inject } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { NgIconComponent, provideIcons, provideNgIconsConfig } from '@ng-icons/core'
import { phosphorStorefront } from '@ng-icons/phosphor-icons/regular'
import { AppService, ShopifyService } from 'src/app/services'
import { environment } from 'src/environments/environment'

@Component({
	selector: 'app-admin-actions',
	standalone: true,
	imports: [FormsModule, NgFor, NgIconComponent],
	providers: [
		provideIcons({
			phosphorStorefront,
		}),
		provideNgIconsConfig({
			size: '16px',
		}),
	],
	templateUrl: './admin-actions.component.html',
	styleUrl: './admin-actions.component.scss',
})
export class AdminActionsComponent {
	store
	stores: Pick<admin.Store, 'apiUrl'>[]
	constructor(
		private shopifyService: ShopifyService,
		private appService: AppService,
		@Inject(DOCUMENT) private document: Document,
	) {
		try {
			if (!environment.production) {
				if (window.localStorage.getItem('store')) {
					this.store = {
						apiUrl: window.localStorage.getItem('store'),
					}
				}
				this.appService.getAllStores().subscribe((data) => {
					this.stores = data
					if (window.localStorage.getItem('store')) {
						this.store = this.stores.find((x) => x.apiUrl === window.localStorage.getItem('store'))
					}
				})
			}
		} catch {}
	}

	submit() {
		if (!environment.production) {
			// window.sessionStorage.setItem('app-bridge-config', JSON.stringify({ apiKey: this.store.apiKey, shop: this.store.apiUrl }))

			this.shopifyService.exchangeSessionForJwt('', this.store.apiUrl).subscribe(
				(token) => {
					this.document['mercuryStore'] = this.store.apiUrl
					this.document[`${this.store.apiUrl}-currentToken`] = JSON.stringify(token)
					try {
						window.localStorage.setItem(this.store.apiUrl + '-currentToken', JSON.stringify(token))
						window.localStorage.setItem('store', this.store.apiUrl)
					} catch {}
					window.location.reload()
				},
				(err) => {
					console.error(err)
				},
			)
		}
	}
}
